import React from 'react';
import './GlobalLoader.scss';

interface GlobalLoaderProps {
  label?: string;
  variant?: 'fullscreen' | 'overlay';
}

/**
 * Branded loading screen. Uses actual Gordian mark (from apple-touch-icon asset)
 * on a soft blurred backdrop. Default label: "Loading".
 */
const GlobalLoader: React.FC<GlobalLoaderProps> = ({ label = 'Loading', variant = 'fullscreen' }) => {
  return (
    <div className={`global-loader global-loader--${variant}`}>
      <div className="global-loader__backdrop" />
      <div className="global-loader__content">
        <div className="global-loader__mark">
          <div className="global-loader__ring" />
          <img
            src="/apple-touch-icon.png"
            alt="Gordian"
            className="global-loader__logo"
          />
        </div>
        <div className="global-loader__brand">Gordian</div>
        <div className="global-loader__label">
          {label}<span className="global-loader__dots">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
